export default {
  ratePlanType: {
    STANDARD: 'Standar',
    BAR: 'Tarif Terbaik Tersedia',
    CORPORATE: 'Korporat',
    MEMBER: 'Anggota',
    PACKAGE: 'Paket',
    PROMOTIONAL: 'Promosi',
    OTA: 'OTA',
    WHOLESALE: 'Grosir',
    NEGOTIATED: 'Negosiasi',
    MIXED: 'Tarif campuran',
  },
} as const;
